<section class="advanced">
  <!-- temp -->
  <button id="Prarmeter" @click="onClickSetting" class="hiddenTrigger">test</button>
  <!-- <teleport to="#layout-extra">
    <Button class="btn-next" @onClick="onClick" text="Adjust Prarmeter"></Button>
  </teleport> -->
  <!-- end of temp -->
  <div class="info">
    <p class="title">{{t('__a7d.__selectCalibrator')}}</p>
    <p class="content">{{t('__a7d.__chooseYourCalibratorYouWantToUse')}}</p>
  </div>
  <div class="select mt35">
    <p class="title">* {{t('__d4e_m8t.__calibratorType')}}</p>
    <Select class="select_ui" :options="state.calibrator_op" v-model:selected="state.calibrator" :isError="false"
      :isDisable="false" @onChange="onChangeCalibrator"></Select>
    <p class="ml36 notice" v-if="state.calibrator['val'] == 4">{{t('__a7d.__thisCalibratorOnlySupportsUpTo')}}</p>
    <Checkbox v-if="state.showCalibratorEmbedded&&state.calibrator.text!='Embedded'" class="ml36 mt21" v-model:isCheck="state.iscalibrator_embedded" text="When the external calibrator cannot be used,auto replace it be the embedded calibrator"></Checkbox>
    
  </div>
  <div class="info mt48">
    <p class="title">{{t('__a7d.__monitorWarmUp')}}</p>
    <p class="content">{{t('__a7d.__selectWhetherYouWant')}}</p>
  </div>
  <div class="radio mt35">
    <Radio class="r_1" v-model:selected="state.selectedWarmUp" value="0" :text="t('__a7d.__autoWarmUp')"></Radio>
    <Radio class="r_2" v-model:selected="state.selectedWarmUp" value="1" :text="t('__a7d.__skipWarmUp')"></Radio>
  </div>
  <div class="info mt48 schedule" ref="schedule">
    <p class="title">{{t('__a7d.__setSchedule')}}</p>
    <p class="content">{{t('__a7d.__setAScheduleToExecuteCalibrationTask')}}</p>
  </div>
  <div class="select mt35 third">
    <p class="title">{{t('__d4e_m8t.__setDate')}}</p>
    <DatePickerSingle class="select_ui" :error="state.forbid" :minDay="state.dateForbid2" @changeDatePicker="changeDatePicker" :value="state.date2" ></DatePickerSingle>
    <!-- <Input class="select_ui" v-model:value="state.date" :error="state.forbid" type="date" :min="state.dateForbid"></Input> -->
    <p class="remind"></p>
  </div>
  <div class="mt24">
    <div class="select third">
      <p class="title">{{t('__a7d.__timeZone')}}</p>
      <Select class="select_ui" :options="state.UTC_op" :error="state.forbid" v-model:selected="state.UTC" 
        :isDisable="false"></Select>
      <p class="remind"></p>
    </div>
    <div class="select ml36 third">
      <p class="title">{{t('__d4e_m8t.__time')}}</p>
      <Select class="select_ui" :options="hour_op" v-model:selected="state.hour" :error="state.forbid"
        :isDisable="false" :isShowErrorTxt="false"></Select>
      <p class="remind"></p>
    </div>
    <div class="select ml36 third">
      <p class="title"></p>
      <Select class="select_ui" :options="second_op" v-model:selected="state.second" :error="state.forbid"
        :isDisable="false" :isShowErrorTxt="false"></Select>
      <p class="remind"></p>
    </div>
  </div>
  <div class="radio mt36">
    <Radio class="check" v-model:selected="state.selectedRepeat" name="002" value="0" :text="t('__a7d.__single')"></Radio>
    <Radio class="check mt36" v-model:selected="state.selectedRepeat" name="002" value="1" :text="t('__a7d.__weeklyRepeat')"></Radio>
    <div class="mt24">
      <div class="select ml36 both">
        <p class="title">{{t('__a7d.__every')}}</p>
        <Select class="select_ui" :options="week_op" v-model:selected="state.week" :isError="false"
          :isDisable="state.selectedRepeat != '1'"></Select>
        <p class="remind"></p>
      </div>
      <div class="select ml36 both">
        <p class="title"></p>
        <Select class="select_ui" :options="state.day_op" v-model:selected="state.day" :isError="false"
          :isDisable="state.selectedRepeat != '1'"></Select>
        <p class="remind"></p>
      </div>
    </div>
    <Radio class="check mt22" v-model:selected="state.selectedRepeat" name="002" value="2" :text="t('__a7d.__monthlyRepeat')"></Radio>
    <div class="mt24">
      <div class="select ml36 both">
        <p class="title">{{t('__a7d.__every')}}</p>
        <Select class="select_ui" :options="month_op" v-model:selected="state.month" :isError="false"
          :isDisable="state.selectedRepeat != '2'"></Select>
        <p class="remind"></p>
      </div>
      <div class="select ml36 both">
        <p class="title"></p>
        <Select class="select_ui" :options="rank_op" v-model:selected="state.rank" :isError="false"
          :isDisable="state.selectedRepeat != '2'"></Select>
        <p class="remind"></p>
      </div>
    </div>
    <Checkbox class="ml36 mt21" :isDisable="state.selectedRepeat != '2'" v-model:isCheck="state.work_day" :text="t('__a7d.__postponeToNextWorkingDay')"></Checkbox>
  </div>
  <div class="info mt48">
    <p class="title">{{t('__a7d.__computerBehaviorAfterCalibration')}}</p>
    <p class="content">{{t('__a7d.__setWhetherToShutDownTheComputer')}}</p>
  </div>
  <div class="radio mt36">
    <Radio class="check" v-model:selected="state.selectedAfter" name="003" value="0" :text="t('__a7d.__noAction')"></Radio>
    <Radio class="check mt36" v-model:selected="state.selectedAfter" name="003" value="1" :text="t('__a7d.__shutDown')"></Radio>
    <Radio class="check mt36" v-model:selected="state.selectedAfter" name="003" value="2" :text="t('__a7d.__goSleep')"></Radio>
  </div>
  <div class="info mt57">
    <p class="title">{{t('__a7d.__setReminder')}}</p>
    <p class="content">{{t('__a7d.__thereIsADefaultReminder')}}</p>
  </div>
  <div class="radio mt35">
    <Radio class="check" v-model:selected="state.selectedReminder" name="004" value="0" :text="t('__a7d.__noAdditionalReminder')">
    </Radio>
    <Radio class="check mt36" v-model:selected="state.selectedReminder" name="004" value="1" :text="t('__a7d.__additionalReminder')">
    </Radio>
    <div class="outside">
      <Checkbox v-for="(value,index) in state.isCheck_Array" :isDisable="state.selectedReminder == '0'" class="click" :class="index!=0&&index!=1?'mt25':'mt26'"
        v-model:isCheck="value.isCheck" :isI18n="value.isI18n" :value="index.toString()" @onChange="isCheckChange" :text="value.text"></Checkbox>
    </div>
  </div>
  <div class="btn">
    <Button :id="$route.name == 'Modify Setting' ?  'GTM__goApplyCheckCalibrator' : 'GTM__goApplyCalibratorOnly' " :disable="state.applyDisable" class="btn-next" @onClick="onClickCheckCalibrator" :text="t('__a7d.__goApply')"></Button>
  </div>
</section>